import React from "react";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { SupportsWebcam } from "../../common/WebCam";

const PhotoGuidelines = injectIntl(({ intl }) => (
  <article className="card">
    <section>
      <p>
        {intl.formatMessage(
          SupportsWebcam ? messages.askPhotoDescription : messages.askPhotoDescriptionNoCam
        )}
      </p>
      <figure>
        <img src="/assets/images/wellness/photo-tips.jpg" alt="1.5fl" />
      </figure>
      <h3>{intl.formatMessage(messages.photoGuidelinesDescription)}</h3>
      <ul>
        <li>{intl.formatMessage(messages.plainBackgroundDescription)}</li>
        <li>{intl.formatMessage(messages.removeHatAndGlassedDescription)}</li>
        <li>{intl.formatMessage(messages.useBrightDescription)}</li>
        <li>{intl.formatMessage(messages.keepStraightDescription)}</li>
      </ul>
      {SupportsWebcam && <p>{intl.formatMessage(messages.permissionDescription)}</p>}
    </section>
  </article>
));

export default PhotoGuidelines;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/photoGuidelines.jsx